import React from 'react'
import { QueryImage } from "../hooks/fibernormImgs.js"
import Img from 'gatsby-image'

const FibernormImgs = () => {
    const allFile = QueryImage()

    return (
        allFile.edges.map((el, i) => (
            <Img
                key={i}
                fluid={el.node.childImageSharp.fluid}
                className="my-3"
                alt="Photo"
            />
        ))

    )
}

export default FibernormImgs